
import { useEffect, useState } from 'react';

export default function PricingHero() {
  const [animated, setAnimated] = useState(false);
  const [currentBg, setCurrentBg] = useState(0);

  useEffect(() => {
    setAnimated(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % 4);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const backgrounds = [
    'https://readdy.ai/api/search-image?query=bright%20modern%20law%20office%20workspace%20with%20natural%20daylight%20streaming%20through%20large%20windows%20elegant%20wooden%20desk%20with%20organized%20legal%20documents%20warm%20beige%20tones%20professional%20legal%20environment%20clean%20minimalist%20design%20high%20key%20lighting%20contemporary%20attorney%20workspace%20sophisticated%20interior%20light%20airy%20atmosphere&width=1920&height=1080&seq=pricingbg1-light-v2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=professional%20lawyers%20shaking%20hands%20in%20bright%20modern%20law%20firm%20lobby%20with%20floor%20to%20ceiling%20windows%20natural%20sunlight%20warm%20beige%20interior%20elegant%20contemporary%20legal%20office%20successful%20business%20agreement%20high%20key%20lighting%20clean%20professional%20photography%20light%20sophisticated%20atmosphere&width=1920&height=1080&seq=pricingbg2-light-v2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=elegant%20law%20firm%20conference%20room%20with%20natural%20daylight%20bright%20windows%20overlooking%20city%20modern%20legal%20office%20interior%20warm%20beige%20wood%20furniture%20professional%20setting%20high%20key%20lighting%20contemporary%20workspace%20clean%20design%20sophisticated%20legal%20environment%20light%20airy%20atmosphere&width=1920&height=1080&seq=pricingbg3-light-v2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=modern%20legal%20technology%20smartphone%20and%20laptop%20on%20elegant%20wooden%20desk%20in%20bright%20law%20office%20natural%20window%20light%20warm%20professional%20atmosphere%20contemporary%20legal%20workspace%20high%20key%20lighting%20clean%20minimalist%20design%20sophisticated%20interior%20light%20beige%20tones&width=1920&height=1080&seq=pricingbg4-light-v2&orientation=landscape'
  ];

  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden bg-[#1a1a1a]">
      {backgrounds.map((bg, index) => (
        <div
          key={index}
          className="absolute inset-0 transition-opacity duration-2000"
          style={{
            opacity: currentBg === index ? 0.5 : 0,
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/5"></div>

      <div className="relative z-10 w-full">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-8 py-16 sm:py-24 lg:py-32">
          <div className="max-w-[900px] mx-auto text-center space-y-4 sm:space-y-6 lg:space-y-8">
            <h1
              className={`font-harvey-serif text-white text-[36px] sm:text-[48px] lg:text-[68px] font-normal leading-[1.05] tracking-tight transition-all duration-700 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
            >
              Founder Pricing
            </h1>

            <p
              className={`font-harvey-sans text-white/90 text-[18px] sm:text-[20px] lg:text-[24px] leading-relaxed font-light tracking-wide transition-all duration-700 delay-200 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              The legal AI lawyers have been waiting for. Private. Mobile. Affordable
            </p>

            <div
              className={`space-y-3 sm:space-y-4 transition-all duration-700 delay-400 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <p className="font-harvey-sans text-white text-[16px] sm:text-[18px] lg:text-[20px] font-medium tracking-wide">
                We're launching soon and opening early access to 500 founding members
              </p>
              <p className="font-harvey-sans text-[#d4af37] text-[16px] sm:text-[18px] lg:text-[20px] font-semibold tracking-wide">
                Lock in the lowest price we'll ever offer. Keep it forever
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
